import { render, staticRenderFns } from "./IndustrySolutions.vue?vue&type=template&id=16d840ac&scoped=true"
import script from "./IndustrySolutions.vue?vue&type=script&lang=js"
export * from "./IndustrySolutions.vue?vue&type=script&lang=js"
import style0 from "./IndustrySolutions.vue?vue&type=style&index=0&id=16d840ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d840ac",
  null
  
)

export default component.exports